module.exports = __webpack_public_path__ + "img/image72.07e6cfd.webp";